import DocsContainer from '../../containers/admin/DocsContainer';

export default function DocBasePage() {
    return (
        <DocsContainer />
    );
}
